"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectPaths = exports.toPathArray = exports.normalizePath = exports.joinPathComponents = exports.joinPaths = exports.toPathString = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const QUOTE_REG = /"/g;
const NONWORD_REG = /\W/;
const notEmpty = (path) => path != null && path !== '';
const escapeComponent = (component) => component == null ? null : String(component).replace(QUOTE_REG, '\\"');
const stringifyPathComponent = (component, { isFirst }) => {
    if (component == null)
        return null;
    if (typeof component === 'number')
        component = String(component);
    else if (component.match(NONWORD_REG))
        return `["${escapeComponent(component)}"]`;
    return (isFirst ? '' : '.') + component;
};
/**
 * Converts an array of keys / path components into a path string.
 *
 * @see joinPaths - for joining multiple paths together
 *
 * @param  {string[]} pathArray - Path array
 * @return {string} - Path string
 */
function toPathString(pathArray) {
    return pathArray
        .map((component, index) => stringifyPathComponent(component, { isFirst: !index }))
        .join('');
}
exports.toPathString = toPathString;
/**
 * Joins two path strings together
 *
 * NOTE: each argument is considered a path, not a path component. This is important when it comes to escaping. If you want to join multiple components, use toPathString
 *
 * @example:
 *     joinPaths('foo', 'bar.baz'); // foo.bar.baz
 *     toPathString(['foo', 'bar.baz']); // foo["bar.baz"]
 *
 * @param  paths - An array of path strings to join
 * @return Full path string
 */
function joinPaths(...paths) {
    return toPathString(lodash_1.default.flatMap(paths.filter(item => notEmpty(item)), lodash_1.default.toPath));
}
exports.joinPaths = joinPaths;
/**
 * Same functionality as toPathString, but has the same API as joinPaths
 */
function joinPathComponents(...pathComponents) {
    return toPathString(pathComponents);
}
exports.joinPathComponents = joinPathComponents;
/**
 * Normalizes path strings to use bracket syntax
 *
 * @example
 * // all of the following are equivalent:
 *  foo.bar.1.2
 *  foo["bar"].1.2
 *  foo['bar'][1][2]
 *
 * // All of them will be normalized to:
 *  foo.bar[1][2]
 *
 * @param  {string} path - Path string
 * @return {string} - Full path string in bracket syntax
 *
 */
function normalizePath(path) {
    return toPathString(lodash_1.default.toPath(path));
}
exports.normalizePath = normalizePath;
/**
 * Right now it's just a wrapper on top of _.toPath, but it could change in the future
 */
function toPathArray(path) {
    return lodash_1.default.toPath(path);
}
exports.toPathArray = toPathArray;
/**
 * Gets a list of all paths in an object
 *
 * @param {Object} input - The object to get paths of
 * @param {object} options - Function options
 * @param {boolean} options.ignoreNull - whether to ignore paths if value is null
 * @return {Array} An array of all paths in the object
 */
function getObjectPaths(input = {}, options = {}) {
    const { ignoreNull = false } = options;
    const paths = [];
    const getPath = (obj, prefix = '') => {
        for (const key in obj) {
            const suffix = key.includes('.') ? `["${key}"]` : key;
            const path = `${prefix}${suffix}`;
            const value = obj[key];
            if (!ignoreNull || value !== null)
                paths.push(path);
            if (lodash_1.default.isArray(value) || lodash_1.default.isPlainObject(value)) {
                getPath(value, `${path}.`);
            }
        }
    };
    getPath(input);
    return paths.map(normalizePath);
}
exports.getObjectPaths = getObjectPaths;
//# sourceMappingURL=index.js.map